import { alias, custom, deserialize, serializable, SKIP } from 'serializr';
import { User } from './user.model';
import dayjs from 'dayjs';
import { Base } from './base.model';
import { PageObject } from './page-object.model';

export class ProvisioningProfile extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public teamId: string;
  @serializable
  public createdById: number;
  @serializable
  public updatedById: number;

  @serializable
  public certFileName: string;
  @serializable
  public provisionFileName: string;

  @serializable(
    alias(
      'certUploadDate',
      custom(
        () => SKIP,
        (v) => {
          if (v) return dayjs(v);
        },
      ),
    ),
  )
  public certUploadDate: Date;
  @serializable(
    alias(
      'profileExpiryDate',
      custom(
        () => SKIP,
        (v) => {
          if (v) return dayjs(v);
        },
      ),
    ),
  )
  public profileExpiryDate: Date;
  @serializable(
    alias(
      'profileCreationDate',
      custom(
        () => SKIP,
        (v) => {
          if (v) return dayjs(v);
        },
      ),
    ),
  )
  public profileCreationDate: Date;
  @serializable(
    alias(
      'profileUploadDate',
      custom(
        () => SKIP,
        (v) => {
          if (v) return dayjs(v);
        },
      ),
    ),
  )
  public profileUploadDate: Date;

  @serializable
  public status: string;
  @serializable
  public certificatePresignedUrl: URL;
  @serializable
  public provisioningProfilePresignedUrl: URL;
  @serializable
  public certificatePemPresignedUrl: URL;
  @serializable
  public csrPresignedUrl: URL;
  @serializable(alias('cerFileSizeInBytes'))
  public cerFileSize: string;
  @serializable(alias('profileFileSizeInBytes'))
  public profileFileSize: string;
  @serializable
  public provisioningProfile: string;
  @serializable
  public certificateCerPresignedUrl: string;
  @serializable
  public certificateCrtPresignedUrl: string;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public deviceUDIDs: string[];

  public createdBy: User;
  public updatedBy: User;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ProvisioningProfile, input));
  }

  get isAwaitingCertificate(): boolean {
    return this.status !== 'CSR_REQUESTED';
  }

  get isAwaitingProfile(): boolean {
    return this.status == 'CSR_REQUESTED';
  }

  get isAwaitingReady(): boolean {
    return (
      this.status == 'CSR_REQUESTED' ||
      this.status == 'AWAITING_FOR_CERTIFICATE' ||
      this.status === 'RE_SIGNING'
    );
  }

  get isProvisionReady(): boolean {
    return this.status == 'AWAITING_FOR_PROVISIONING_PROFILE';
  }

  get isProvisionReadyUpload(): boolean {
    return (
      this.status !== 'AWAITING_FOR_CERTIFICATE' &&
      this.status !== 'CSR_REQUESTED'
    );
  }

  get isProvisioningProfile(): boolean {
    return (
      this.status == 'AWAITING_FOR_PROVISIONING_PROFILE' ||
      this.status == 'READY' ||
      this.status.includes('RE_SIGNING')
    );
  }

  get isResigning(): boolean {
    return this.status == 'RE_SIGNING';
  }
}
